import {
  treeActionTypes as TreeTypes,
  apiActionTypes as APIActionTypes,
  apiTypes as APITypes,
  chainedApiActionTypes as ChainedApiActionTypes
} from '../constants';
import { buildTree } from '../util/TreeUtils';

const initialState = {
  nodeId: 0,
  nodesList: [],
  linksList: [],
  selectedNode: null,
  deletingNode: false
};

export default function TreeReducer(state = initialState, action) {
  switch (action.type) {
    case ChainedApiActionTypes.CREATE_NEW_ORCH_SUCCESS:
    case APIActionTypes.UPDATE_ORCH_VER_SUCCESS:
    case APIActionTypes.ORCH_VERSION_SUCCESS: {
      const {
        orchestration_version: { nodes, state: versionState }
      } = action.response;
      return {
        ...state,
        ...buildTree(nodes, versionState !== APITypes.VERSION_STATE_DRAFT)
      };
    }

    case APIActionTypes.UPDATE_ORCH_VER_STATE_SUCCESS: {
      const { version: { nodes }, versionState } = action.payload;
      return {
        ...state,
        ...buildTree(nodes, versionState !== APITypes.VERSION_STATE_DRAFT)
      };
    }

    case TreeTypes.SELECT_NODE:
      return {
        ...state,
        selectedNode: action.payload.nodeId
      };
    case APIActionTypes.CREATE_ORCH_VER_CREATIVE_SUCCESS:
    case TreeTypes.DESELECT_NODE:
      return {
        ...state,
        selectedNode: null,
        deletingNode: false
      };
    case TreeTypes.START_DELETING_NODE:
      return {
        ...state,
        deletingNode: true
      };
    case TreeTypes.STOP_DELETING_NODE:
      return {
        ...state,
        deletingNode: false
      };
    case TreeTypes.CLEAR_TREE:
      return {
        ...state,
        nodesList: [],
        linksList: [],
        selectedNode: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tree.js